import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

import { awardQuerySchema } from './award-query-schema';

import { awardTypeFormSchema } from '../components/award-type';

export const awardFormSchema = awardQuerySchema
  .omit({
    brand_id: true,
    client_id: true,
  })
  .extend({
    name: z.string().min(2),
    sponsoring_organization: z.string(),
    notes: z.string(),
    award_type: awardTypeFormSchema.nullable(),

    award_month: z.object({ name: z.string(), value: z.number() }).nullable(),
    award_year: z.object({ name: z.string(), value: z.string() }).nullable(),

    gallery: z.array(fileQuerySchema),
  });

export type AwardFormSchema = z.infer<typeof awardFormSchema>;
